import { a as get, l as post } from "./utils2.mjs";

//#region src/api/cloudPlans.ts
async function getCurrentPlan(context) {
	return await get(context.baseUrl, "/admin/cloud-plan");
}
async function getCurrentUsage(context) {
	return await get(context.baseUrl, "/cloud/limits");
}
async function getCloudUserInfo(context) {
	return await get(context.baseUrl, "/cloud/proxy/user/me");
}
async function getUpgradeOffer(context) {
	return await post(context.baseUrl, "/cloud/proxy/upgrade-offer");
}
async function sendConfirmationEmail(context) {
	return await post(context.baseUrl, "/cloud/proxy/user/resend-confirmation-email");
}
async function getAdminPanelLoginCode(context) {
	return await get(context.baseUrl, "/cloud/proxy/login/code");
}
async function sendUserEvent(context, eventData) {
	return await post(context.baseUrl, "/cloud/proxy/user/event", eventData);
}

//#endregion
export { getUpgradeOffer as a, getCurrentUsage as i, getCloudUserInfo as n, sendConfirmationEmail as o, getCurrentPlan as r, sendUserEvent as s, getAdminPanelLoginCode as t };
//# sourceMappingURL=cloudPlans.mjs.map